import { SvgIcon } from "@mui/material";
import { IStyleProps } from "@/models";
import { memo } from "react";
import clsx from "clsx";

const MinusFillSquare = ({ sx, className, ...otherProps }: IStyleProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{
        fontSize: "inherit",
        ...sx,
      }}
      className={clsx("icon-MinusFillSquare", className)}
      {...otherProps}
    >
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"></path>
    </SvgIcon>
  );
};
export default memo(MinusFillSquare);
